.progressCard > div {
  block-size: 100%;
  grid-template-rows: auto 1fr;
}

.progressContainer {
  padding-block-start: var(--mtds-6);
}

.progressContainer > mtds-chart {
  grid-template-rows: auto 1fr;
  align-items: end;
}
